import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VendorLanding from "./pages/VendorLanding";
import GastrofestLanding from "./pages/GastrofestLanding";
import LuhacoviceLanding from "./pages/LuhacoviceLanding";
import DenZlinskehokrajeLanding from "./pages/DenZlinskehokrajeLanding";
import OtrokoviceLanding from "./pages/OtrokoviceLanding";
import KoupacekLanding from "./pages/KoupacekLanding";
import BurgerFestLanding from "./pages/BurgerFestLanding";
import MajofestLanding from "./pages/MajofestLanding";
import PublicEventSelector from "./pages/PublicEventSelector";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminOverview from "./pages/AdminOverview";
import EventSelector from "./pages/EventSelector";
import ApplicationStatus from "./pages/ApplicationStatus";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicEventSelector />} />
          <Route path="/kontakt-fest" element={<VendorLanding />} />
          <Route path="/gastrofestival" element={<GastrofestLanding />} />
          <Route path="/cesta-kolem-sveta" element={<GastrofestLanding />} />
          <Route path="/luhacovice" element={<LuhacoviceLanding />} />
          <Route path="/gastrofestival-luhacovice" element={<LuhacoviceLanding />} />
          <Route path="/den-zk" element={<DenZlinskehokrajeLanding />} />
          <Route path="/den-zlinskeho-kraje" element={<DenZlinskehokrajeLanding />} />
          <Route path="/majofest" element={<MajofestLanding />} />
          <Route path="/burger-fest" element={<BurgerFestLanding />} />
          <Route path="/otrokovice" element={<OtrokoviceLanding />} />
          <Route path="/koupacek" element={<KoupacekLanding />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/overview" element={<AdminOverview />} />
          <Route path="/admin/events" element={<EventSelector />} />
          <Route path="/admin/dashboard/:eventId" element={<AdminDashboard />} />
          <Route path="/status/:id" element={<ApplicationStatus />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
